export default __webpack_public_path__ + "static/media/FALCON-RETRACTABLE-ROOF-HYDERABAD.afa59fdf.jpg";